import { Entity, Field } from '@adornis/baseql/decorators.js';
import { Counter } from '@adornis/counter/counter.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';
import { BHOrderNr } from '../../entities/BHPayment.js';

@Entity()
export class BHSDOrderNr extends BHOrderNr {
  static override _class = 'BHSDOrderNr';

  @validate(nonOptional())
  @Field(type => String)
  type!: 'intern' | 'extern';

  static override async create(institutionID: string, type: 'intern' | 'extern') {
    const year = DateTime.now().year;
    const nr = await Counter.getIncrementingNumber(institutionID + '::orderCounter::' + type + '::' + year)();
    return new BHSDOrderNr({ year, nr, type });
  }

  override getOrderNr() {
    const padNr = this.nr.toString().padStart(4, '0');

    if (this.type === 'intern') return `${this.year}/SD/${padNr}`;
    if (this.type === 'extern') return `SD/${this.year}/DRA/${padNr}`;
    throw new Error('should be unreachable');
  }
}
